const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Élan",

  webfeedDebuggerWebsiteUrl: "https://elan.avid.com.au/masterplan/",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
